import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { bool, func, string } from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import FormLabel from 'react-bootstrap/FormLabel';
import FormGroup from 'react-bootstrap/FormGroup';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useUserLogin } from '../../hooks/useApi';
import { useLocalStorage, writeStorage } from '@rehooks/local-storage';
import { CloseButton, SaveButton } from '../../components/ActionButtons';

function ReEnterPassword(props) {
  const { show, onClose, newPracticeId: practiceId } = props;
  const history = useHistory();
  const [email] = useLocalStorage('__email__');

  const { register, handleSubmit, errors } = useForm({
    defaultValues: {
      password: '',
    },
    reValidateMode: 'onChange',
  });

  const { mutate } = useUserLogin((data) => {
    toast.success('Practice Successfully Changed');
    const { practiceId, token, providerId, type } = data;
    writeStorage('__token__', token);
    writeStorage('__practiceId__', practiceId);
    writeStorage('__providerId__', providerId);
    writeStorage('__type__', type);
    onClose();
    history.push('/appointment');
  });

  function onSubmit(data) {
    mutate({ email, practiceId, ...data });
  }

  return (
    <Modal show={show} backdrop={'static'} centered onHide={onClose}>
      <Modal.Header closeButton>Re-Enter Password</Modal.Header>
      <Modal.Body>
        <p>For security reason, please re enter your password</p>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <FormGroup>
            <FormLabel>Enter Password</FormLabel>
            <FormControl autoComplete={'current-password'} name={'password'} ref={register({ required: true })} type={'password'} isInvalid={errors.password} />
            {errors.password && <Form.Text className={'text-danger'}>password field cannot be empty</Form.Text>}
          </FormGroup>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <SaveButton btnText={'Submit'} onClick={handleSubmit(onSubmit)} />
        <CloseButton onClick={onClose} />
      </Modal.Footer>
    </Modal>
  );
}

ReEnterPassword.propTypes = {
  onClose: func,
  show: bool,
  newPracticeId: string.isRequired,
};

export default memo(ReEnterPassword);
